
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetHerbs } from "../../request";

@Component({})
export default class PrescriptionSelect extends Vue {
    @Prop({ type: String, default: "" })
    private name!: string;
    @Watch('name', { immediate: true })
    private onNameChange(newVal: string) {
        this.data = this.name;
    }

    private data: any = ''
    private medicineOptions: any[] = []

    private async handleMedicineChange(e: any) {
        // if (e.trim() === '') {
        //     this.medicineOptions = [
        //         { id: 1, name: "人参" },
        //         { id: 2, name: "紫苏叶" },
        //         { id: 3, name: "葛根" },
        //         { id: 4, name: "前胡" },
        //         { id: 5, name: "半夏" },
        //         { id: 6, name: "茯苓" },
        //         { id: 7, name: "陈皮" },
        //         { id: 8, name: "枳壳" },
        //         { id: 9, name: "桔梗" },
        //         { id: 10, name: "木香" },
        //         { id: 11, name: "甘草" },
        //         { id: 12, name: "当归" },
        //         { id: 13, name: "川芎" },
        //         { id: 14, name: "白芍" },
        //         { id: 15, name: "熟地黄" },
        //         { id: 16, name: "黄芪" },
        //         { id: 17, name: "白术" },
        //         { id: 18, name: "党参" },
        //         { id: 19, name: "山药" },
        //         { id: 20, name: "枸杞子" }]
        // } else {
        //     console.log('随机生成')
        //     // 根据e生成10个选项
        //     this.medicineOptions = Array.from({ length: 10 }, (_, i) => ({
        //         id: i + 1,
        //         name: `${e}${i + 1}`
        //     }))
        // }
        const params: any = {
            params: {
                search: e.trim(),
            },
        };
        const res = await GetHerbs(this, params);
        this.medicineOptions = res.data;
    }
    private valueChange(val: any) {
        // 找到选中的药材对象，传递完整信息
        const selectedMedicine = this.medicineOptions.find(medicine => medicine.name === val);
        if (selectedMedicine) {
            this.$emit('change', selectedMedicine);
        } else {
            this.$emit('change', val);
        }
    }

}
